






import Vue from 'vue';

import HostedPaymentCreateOrEdit from './HostedPaymentCreateOrEdit.vue';

export default Vue.extend({
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  created() {
    document.title = 'RiseOS-Edit Hosted Payment';
  },
  methods: {
  },
  components: {
    HostedPaymentCreateOrEdit,
  },
});
